import { ReactNode } from 'react';
import { Root } from './grid.styles';
interface GridProps {
    children: ReactNode;
    columns?: string;
    rows?: string;
    gap?: number | string;
}
/**
 * Grid Component
 *
 * A customizable grid layout component that lets you define grid columns, rows, and gap.
 *
 * Usage Example:
 * <Grid columns="1fr auto" rows="20px auto" gap="16px">
 *   <div>Item 1</div>
 *   <div>Item 2</div>
 * </Grid>
 */
export function Grid({ children, columns, rows, gap }: GridProps) {
    return (
        <Root columns={columns} rows={rows} gap={gap}>
            {children}
        </Root>
    );
}
